export function dedupeModelsForPicker(models: string[]): string[] {
  const hasAuto = models.includes('auto');
  const filtered = models.filter(m => !(m === 'default' && hasAuto));
  return [...new Set(filtered)];
}

export function normalizeModelForPickerState(
  current: string,
  deduped: string[],
): string {
  if (deduped.length === 0) return current;
  const mapped =
    current === 'default' && deduped.includes('auto') ? 'auto' : current;
  if (deduped.includes(mapped)) return mapped;
  return deduped[0];
}

export function compactModelButtonLabel(model: string): string {
  if (model === 'auto' || model === 'default') return 'auto';
  return model;
}
